import { useIntl } from "react-intl";
import Checkbox from "components/v2/Checkbox/Checkbox";

interface PackingListBasicChecksProps {
  index: number;
}

export default function PackingListBasicChecks({ index }: PackingListBasicChecksProps) {
  const intl = useIntl();
  return (
    <>
      <Checkbox
        name={`packing_list.${index}.stackable`}
        label={intl.formatMessage({ id: "new-request.packing-list.stackable", defaultMessage: "Stackable" })}
        size="sm"
      />
      <Checkbox
        name={`packing_list.${index}.hazardous`}
        label={intl.formatMessage({ id: "new-request.packing-list.hazardous", defaultMessage: "Hazardous" })}
        size="sm"
      />
      <div />
    </>
  );
}
